import axios from 'axios';
import envConfig from "../config/envConfig.js";

const apiServiceAdmin = axios.create({
    baseURL: `${envConfig.API_URL}/admin/`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true, // Include the cookies in the request
});

export default apiServiceAdmin;